import React, { useState, useEffect } from 'react';
import { Card, Button, message, Checkbox } from 'antd';
import { isEmpty } from 'script/common';

const CommonAppFavicon = ({ t, onFileSelect, fileKey, settingData }) => {
	const [selectedFile, setSelectedFile] = useState({});

	const handleFileChange = (e) => {
		const file = e.target.files[0];

		// 파일 입력 초기화
		e.target.value = null;

		if (file) {
			// 파일 크기 제한 체크 (2MB 미만)
			if (file.size > 2 * 1024 * 1024) {
				message.error(t('settings.msg.invalidFaviconImage'));
				return;
			}
			
			// 파일 포맷 체크 (ico, svg, png, jpg, webp)
			const validFormats = ['image/x-icon', 'image/svg+xml', 'image/png', 'image/jpeg', 'image/webp'];
			if (!validFormats.includes(file.type)) {
				message.error(t('settings.msg.invalidFaviconFormat'));
				return;
			}

			onFileSelect({ [fileKey]: file });
			setSelectedFile(file);
		}
	};

	const handleFileRemove = () => {
		setSelectedFile(null);
		onFileSelect({ [fileKey]: null });
	};

	const getFaviconFileName = () => {
		if(!selectedFile) {
			return t('settings.msg.noFileChosen');
		}
		if (!settingData?.appFaviconImage?.fileName && !isEmpty(selectedFile)) {
			return selectedFile.name
		}
		if (!settingData?.appFaviconImage?.fileName && isEmpty(selectedFile)) {
			return t('settings.msg.noFileChosen');
		}
		if (settingData?.appFaviconImage?.fileName && !isEmpty(selectedFile)) {
			return selectedFile.name;
		}
		if (settingData?.appFaviconImage?.fileName && isEmpty(selectedFile)) {
			return settingData?.appFaviconImage?.fileName;
		}
	};

	return (
		<div>
		<Card type="inner" title="Common" style={{ margin: 20 }}>
			<div>
				<label id={`label_file_${fileKey}`} style={{ margin: 20 }}>
					{getFaviconFileName()}
				</label>
				<input
					type="file"
					accept=".ico, .svg, .png, .jpg, .jpeg, .webp"
					id={`favicon_image_${fileKey}`}
					onChange={handleFileChange}
					style={{ display: "none" }}
				/>
				<Button onClick={() => document.getElementById(`favicon_image_${fileKey}`).click()}>
					{t('settings.button.browseFile')}
				</Button>
				<Button
						type="default"
						onClick={handleFileRemove}
						style={{ marginLeft: 10 }}
						disabled={isEmpty(selectedFile) && !settingData?.appFaviconImage?.fileName}
					>
						{t('settings.button.removeFile')}
				</Button>

			</div>
		</Card>
	</div>
		
	);
};

export default CommonAppFavicon;